export const MAX_SCORE = 100000;
